import React from 'react';

interface BackButtonProps {
  onClick: () => void;
  text?: string;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ 
  onClick, 
  text = "← Назад",
  className = ""
}) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center transition-colors ${className || "text-blue-600 hover:text-blue-800"}`}
    >
      <svg 
        className="w-4 h-4 mr-2" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M15 19l-7-7 7-7" 
        />
      </svg>
      {text}
    </button>
  );
};

export default BackButton;
